module.exports = __webpack_public_path__ + "static/img/头像4.c77fccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/头像4.png
// module id = bbU7
// module chunks = 1